import { useEffect, useRef } from 'react';
import { useApp } from '../context/AppContext';

const DEFAULT_STATUSES = [
  {
    status_id: 'todo',
    label: 'Zu erledigen',
    color: 'bg-gray-100',
    text_color: 'text-gray-700',
    icon: 'FiCircle',
    order: 1,
    is_default: true,
  },
  {
    status_id: 'inprogress',
    label: 'In Arbeit',
    color: 'bg-blue-100',
    text_color: 'text-blue-700',
    icon: 'FiLoader',
    order: 2,
    is_default: true,
  },
  {
    status_id: 'waiting',
    label: 'Warten',
    color: 'bg-yellow-100',
    text_color: 'text-yellow-700',
    icon: 'FiClock',
    order: 3,
    is_default: true,
  },
  {
    status_id: 'done',
    label: 'Erledigt',
    color: 'bg-green-100',
    text_color: 'text-green-700',
    icon: 'FiCheckCircle',
    order: 4,
    is_default: true,
  },
];

const VALID_PRIORITIES = new Set(['low', 'medium', 'high']);

const TaskStatusRecovery = () => {
  const { loading, isAuthenticated, taskStatusesLoaded, tasks, taskStatuses, addTaskStatus } = useApp();
  const isAddingRef = useRef(false);

  tasks.forEach((task) => {
    if (task.priority === 'urgent') {
      task.priority = 'high';
    } else if (!VALID_PRIORITIES.has(task.priority)) {
      task.priority = 'medium';
    }
  });

  useEffect(() => {
    // Warten, bis die Collection wirklich gelesen wurde. Ohne diese Bedingung
    // legt die App beim Login die Defaults doppelt an: login() setzt
    // isAuthenticated VOR dem Datenladen, taskStatuses ist dann noch leer.
    if (loading || !isAuthenticated || !taskStatusesLoaded || isAddingRef.current) return;

    const existingIds = new Set(
      taskStatuses.map((status) => status.status_id || status.id)
    );
    const missingStatus = DEFAULT_STATUSES.find(
      (status) => !existingIds.has(status.status_id)
    );

    if (!missingStatus) return;

    isAddingRef.current = true;
    addTaskStatus(missingStatus).finally(() => {
      isAddingRef.current = false;
    });
  }, [loading, isAuthenticated, taskStatusesLoaded, taskStatuses, addTaskStatus]);

  return null;
};

export default TaskStatusRecovery;